module.exports = __webpack_public_path__ + "assets/img/plant-1.9097df10.png";